import React from 'react'
import { Text } from '@workwhile/ui'

export const ErrorMessage = ({ error }: { error: string | undefined }) => {
  if (!error) {
    return null
  }

  return <Text color="error200">{error}</Text>
}
